// axios配置文件
import axios from "axios";
import { Messages as Message } from "../UI";
import { addParams } from "./commonParams";
import { getCookieVal } from "@/tool/index";
import { refreshLoginInfo } from "./updateToken";
import { removeToken } from "./localToken";
import store from "../store";

const service = axios.create({
  baseURL: process.env.VUE_APP_API, // API的base_url
  timeout: 300000, // 增加超时时间到5分钟
  // 添加重试配置
  retry: 3, // 重试次数
  retryDelay: 1000, // 重试间隔
  shouldRetry: (error) => {
    // 判断是否需要重试
    return (
      error.code === "ECONNABORTED" ||
      error.response?.status === 504 ||
      error.message.includes("Network Error")
    );
  },
});
let flag = false;
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.sign) addParams(config);
    refreshLoginInfo();
    config.headers.token = getCookieVal("iyuanwu_token");
    return config;
  },

  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做处理，例如只返回data部分
    const data = response.data;
    if (data.code == 2) {
      Message({
        type: "error",
        message: data.message,
      });
    }
    if (data.code == 403 || (data && data.code == 404 && !flag)) {
      removeToken(); // 移除token
      Message({
        type: "error",
        message: "请先登录！",
      });
      flag = true;
      store.dispatch("setLoginShow", true);
    }
    return data;
  },
  async (error) => {
    const config = error.config;
    // 如果不需要重试，直接返回错误
    if (!config || !config.retry || !config.shouldRetry(error)) {
      return Promise.reject(error);
    }
    // 设置重试计数
    config.__retryCount = config.__retryCount || 0;
    // 如果已经到达最大重试次数，返回错误
    if (config.__retryCount >= config.retry) {
      return Promise.reject(error);
    }
    // 增加重试计数
    config.__retryCount += 1;

    // 创建新的Promise来处理重试
    const backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1);
    });

    // 重试请求
    await backoff;
    return service(config);
  }
);

// 创建一个新的请求实例用于直接访问特定服务器
export const directService = axios.create({
  baseURL: "http://192.168.1.13:5001",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

directService.interceptors.request.use(
  (config) => {
    if (config.sign) addParams(config);
    refreshLoginInfo();
    config.headers.token = getCookieVal("iyuanwu_token");
    config.headers.tokenInfo =
      "eyJ1c2VySWQiOiAiMzU3NDgxMzQ5ODY0NDg4OTYiLCAib3JnQ29kZSI6ICIzNTc0ODEzNTAyNDE5NzYzMiIsICJlbXBsb3lJZCI6ICIyMjI5MzEiLCAiY2FpaG9uZ0lkIjogIjcxMzg0NzY3IiwgImxvZ2luVGltZSI6ICIxNzM5NzcwNzQ0MjgwIiwgInBob25lIjogIjE4OTUwMTM1NzYyIiwgInBsYXRmb3JtVHlwZSI6ICJQQyIsICJjbGllbnRUeXBlIjogIkNBSUhPTkciLCAidG9rZW5UeXBlIjogIlVTRVIiLCAicmVmcmVzaFRva2VuIjogImJkNzM0MmNiOTkwMjRiNDU5MTRmNmQyZGU5NGQ0YzdlIiwgImFjY291bnRJZCI6IG51bGwsICJvcmdUeXBlIjogIkVNUFRZIn0K";
    return config;
  },

  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

directService.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
